import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=169a9054&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=169a9054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169a9054",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('169a9054')) {
      api.createRecord('169a9054', component.options)
    } else {
      api.reload('169a9054', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=169a9054&scoped=true&", function () {
      api.rerender('169a9054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ay15uLUk0K6d/JS/comp/CookieBox.vue"
export default component.exports